import { render, staticRenderFns } from "./SemenCollectionone.vue?vue&type=template&id=40014a0e&scoped=true&"
import script from "./SemenCollectionone.vue?vue&type=script&lang=js&"
export * from "./SemenCollectionone.vue?vue&type=script&lang=js&"
import style0 from "./SemenCollectionone.vue?vue&type=style&index=0&id=40014a0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40014a0e",
  null
  
)

export default component.exports